// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df1c169e","455":"2ee98f26","977":"cedbadf3"}[chunkId] + ".chunk.js";
};